const NavHistoryTitle = function(value) {
    if (!value) return ''
    if (value.length > 17) {
        return value.slice(0, 17) + '...'
    }
    return value
}
const NavHistoryName = function(value) {
    if (!value) return ''
    if (value.length > 11) {
        return value.slice(0, 11) + '...'
    }
    return value
}
const seniorityName = function(value) {
    if (!value) return ''
    if (value.length > 8) {
        return value.slice(0, 8) + '...'
    }
    return value
}
const cardBrief = function(value) {
    if (!value) return '有点懒！什么都没有留下'
    if (value.length > 18) {
        return value.slice(0, 18) + '...'
    }
    return value
}
const GiftName = function(value) {
    if (!value) return ''
    if (value.length > 5) {
        return value.slice(0, 5) + '...'
    }
    return value
}
export {
    NavHistoryTitle,
    NavHistoryName,
    seniorityName,
    cardBrief,
    GiftName
}


// WEBPACK FOOTER //
// ./src/filters/index.js